import React from 'react';
import ContentLayout from '../../layout/ContentLayout';
import AgentTable from '../../components/agent/AgentTable';

export default function Agents() {
  return (
    <ContentLayout>
      <AgentTable />
    </ContentLayout>
  );
}
